module.exports = __webpack_public_path__ + "static/media/login-background.ce89140d.jpg";